/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';

const state = {
  product: {
    zones: [],
    partners: [],
  },
  coordinates: [],
  conferenceUrls: [],
  error: null,
};

const getters = {
  product: state => state.product,
  name: state => state.product.name,
  selectedProductId: state => state.product.id,
  coordinates: state => state.coordinates,
  conferenceUrls: state => state.conferenceUrls,
  error: state => state.error,
};

const actions = {
  fetch({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/products/${payload.id}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  fetchConference({ commit }, payload) {
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/products/conference/${payload.url}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  saveProduct({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    let request;
    if (payload.product.id) {
      request = Vue.http.put(`${process.env.BACKEND_API_URL}api/${path}/products/${payload.product.id}`, payload.product);
    } else {
      request = Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/products`, payload.product);
    }
    return request
      .then((response) => {
        commit(mTypes.DATA_STORED, response);
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  saveOrder({commit}, { user, order, tenantId }) {
    const path = `${user.data.selectedRole.role}s/${user.data.selectedRole.id}`;
    const request = Vue.http.put(`${process.env.BACKEND_API_URL}api/${path}/products/saveOrder`, { order, tenantId });
    return request;
  },
  delete({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/products/${payload.id}`)
      .then(() => {})
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  conferenceUrls({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/products/conferenceUrls/${payload.id}`)
      .then((response) => {
        commit(mTypes.URLS_FETCHED, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, product) {
    state.product = product.data;
    state.coordinates = [];
    if (state.product.zones) {
      state.product.zones.forEach((el) => {
        if (el.coordinates) {
          state.coordinates.push(el.coordinates);
        }
      });
    }
    state.error = null;
  },
  [mTypes.CLEAR_STATE](state) {
    state.product = {};
    state.coordinates = [];
  },
  [mTypes.DATA_STORED](state, product) {
    state.product = product.data;
    state.coordinates = [];
    if (state.product.zones) {
      state.product.zones.forEach((el) => {
        if (el.coordinates) {
          state.coordinates.push(el.coordinates);
        }
      });
    }
  },
  [mTypes.URLS_FETCHED](state, result) {
    state.conferenceUrls = result.data;
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/products/product.js